<template>
        <div class="right_block">
            <i v-if="showRightTable && rightTableData.length === 0" class="rot fa-6x fa-regular fa-gear"></i>
            <fieldset v-if="showRightTable === false" class="right_block__fieldset fieldset_requirements">
                <legend>Предпросмотр</legend>
                <div class="fieldset_requirements__statuses">
                    Для отображения таблицы требуется:
                    <span v-if="params.categoryType !=='absent' && params.categoryType !=='priceless'" :class="categorySelected ? 'status_accept' : 'status_deny'">
                        <i :class="categorySelected ? 'far fa-circle-check' : 'fas fa-xmark'"/>Категория
                    </span>
                    <span :class="nameSelected ? 'status_accept' : 'status_deny'">
                        <i :class="nameSelected ? 'far fa-circle-check' : 'fas fa-xmark'"/>Наименование
                    </span>
                    <span :class="priceSelected ? 'status_accept' : 'status_deny'">
                        <i :class="priceSelected ? 'far fa-circle-check' : 'fas fa-xmark'"/>Цена
                    </span>
                </div>
            </fieldset>
            <fieldset v-if="showRightTable && rightTableData.length !== 0" class="right_block__fieldset fieldset_table">
                <legend>Предпросмотр результата</legend>
                <table ref="rightTable" class="table_right" :class="{loading: rightTableLoaded === false}">
                    <tr class="table_right__tr table_right__tr_head">
                        <th v-if="hasCode" class="table_right__th_code">Код</th>
                        <th :class="hasCode ? 'narrowName' : 'wideName'">Название и Описание</th>
                        <th class="table_right__th_price">Цена</th>
                    </tr>
                        <template v-for="(catItems1, mainCat) in rightTableData">
                            <tr v-if="params.categoryType !=='absent'" class="table_right__tr">
                                <td class="table_right__td_category" colspan="100%" v-if="mainCat !== ''">{{mainCat}}</td>
                                <td class="table_right__td_category td_category_empty" colspan="100%" v-else>БЕЗ КАТЕГОРИИ</td>
                            </tr>
                            <template v-for="(catItems2, subCat1) in catItems1">
                                <tr v-if="subCat1" class="table_right__tr">
                                    <td class="table_right__td_category table_right__td_subcategory1" colspan="100%">{{subCat1}}</td>
                                </tr>
                                <template v-for="(catItems3, subCat2) in catItems2">
                                    <tr v-if="subCat2" class="table_right__tr">
                                        <td class="table_right__td_category table_right__td_subcategory2" colspan="100%">{{subCat2}}</td>
                                    </tr>

                                    <tr v-for="item in catItems3" class="table_right__tr table_right__tr_service">
                                        <td v-if="hasCode" class="table_right__td_code">{{item.code}}</td>
                                        <td class="table_right__td_name">
                                            {{item.name}}
                                            <template v-if="item.description">
                                                <br>
                                                {{item.description}}
                                            </template>
                                        </td>
                                        <td class="table_right__td_price">{{item.priceOutputString}}</td>
                                    </tr>
                                </template>
                            </template>
                        </template>
                </table>
            </fieldset>
        </div>
</template>
<script>

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
    data: function () {
        return {
            request: null,
            rightTableData:[]
        };
    },
    created (){
        this.$bus.listen('pricelist_file_changed', () => {
            if(this.showRightTable){
                this.refreshRightTable();
            }
        })
    },
    methods: {
        ...mapActions({
            resetErrors: 'stepTwo/resetErrors'
        }),
        ...mapMutations({
            setInfo: 'stepTwo/setInfo',
            setRTStatus: 'stepTwo/setRTStatus',
        }),
        refreshRightTable() {
            this.setRTStatus(false)
            if (this.request) {
                this.request.cancel();
            }
            this.request = this.axios.CancelToken.source();
            let requestPromise = this.axios.post('doctu/parse/' + this.priceListFileId,
                {'params': this.params}, {cancelToken: this.request.token});

            requestPromise.then((response) => {
                    this.rightTableData = response.data.data;
                    this.setInfo(response.data.info);
                    this.setRTStatus(true)
                },
                () => {});
            return requestPromise;
        },
    },

    computed: {
        ...mapGetters({
            categorySelected: 'stepTwo/categorySelected',
            priceSelected: 'stepTwo/priceSelected',
            nameSelected: 'stepTwo/nameSelected',
            hasCode: 'stepTwo/codeSelected',
            showRightTable: 'stepTwo/showRightTable',
        }),
        ...mapState({
            priceListFileId: state => state.stepTwo.priceListFileId,
            params: state => state.stepTwo.params,
            rightTableLoaded: state => state.stepTwo.rightTableLoaded,
        }),
    },
    watch: {
        showRightTable (newVal){
                if (newVal === false){
                        this.resetErrors();
                        this.rightTableData = [];
                }
            },
        params: {
            deep: true,
            immediate: false,
            handler: function(newVal) {
                if(this.showRightTable){
                    this.refreshRightTable();
                }
            }
        },
    }
}
</script>
<style scoped>
.right_block {
    float: right;
    width: 49%;
    height: 100%;
}

.fieldset_requirements {
    height: 100%;
}
.fieldset_requirements__statuses {
    display: inline-grid;
    padding-left: 28%;
    padding-top: 40%;
}

.fieldset_table {
    height: 100%;
    overflow: scroll;
}
.status_deny, .status_accept > .far, .fas {
    padding-right: 7px
}
.status_deny {
    margin-left: 19%;
    color: red;
}
.status_accept {
    margin-left: 18%;
    color: green;
}
.table_right__tr {
    width: inherit;
}
.table_right {
    width: 100%;
    table-layout: fixed;
    font-size: 0.7em;
}
.table_right th {
    border: 1px solid #e6e4e4;
    text-align: center;
}
.table_right__th_price{
    width: 15%;
}
.table_right__th_code{
    width: 14%;
}
.table_right td {
    border: 1px solid #e6e4e4;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 17px;
    white-space: nowrap;
    min-width: 50px;
    padding: 1px 4px 2px 6px;
}
.table_right__td_category{
    height: 50px;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    background: #bebebe;
}
.table_right__td_subcategory1 {
    background: #d5d5d5;
}
.table_right__td_subcategory2 {
    background: #b1b1b12e;
}
.table_right__tr_service {
    font-size: 0.8em;
}
.table_right__tr_head{
    background: #999;
}
.table_right__td_name{
    padding-left: 20px !important;
}
.narrowName{
    width: 71%;
}
.wideName{
    width: 89%;
}
.table_right__td_price{
    text-align: right;
}
.td_category_empty{
    color: red;
}
i.rot {
    position: fixed;
    top: 318px;
    left: 67%;
    color: #b9bec7a3;
    animation: 2s linear 0s normal none infinite running rot;
    -webkit-animation: 2s linear 0s normal none infinite running rot;
}
@keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
